<template>
    <canvas class="w-full h-full" ref="canvas" width="50" height="50" />
</template>

<script>
    import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
    import {
        Chart,
        ArcElement,
        DoughnutController,
        LinearScale,
    } from 'chart.js'

    Chart.register(
        ArcElement,
        DoughnutController,
        LinearScale,
    )

    export default {
        setup() {
            let interval
            const scrollHeight = ref(document.body.scrollTop || document.documentElement.scrollTop)
            const pageHeight = ref(document.documentElement.scrollHeight - document.documentElement.clientHeight)
            const progress = computed(() => {
                let percentage = scrollHeight.value / pageHeight.value

                if (percentage >= 1) {
                    return 100
                }

                if (pageHeight.value === 0) {
                    return 0
                }

                return Math.round((scrollHeight.value / pageHeight.value) * 100)
            })

            const canvas = ref(null)
            const parameters = {
                type: 'doughnut',
                data: {
                    datasets: [{
                        data: [progress.value, 100 - progress.value],
                        backgroundColor: [
                            '#025BC4',
                            '#D1D5DB',
                        ]
                    }]
                },
                options: {
                    cutout: '80%',
                    elements: {
                        arc: {
                            borderWidth: 0
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    events: []
                },
                plugins: [{
                    id: 'text',
                    beforeDraw: function(chart) {
                        const width = chart.width,
                            height = chart.height,
                            ctx = chart.ctx
                        const fontSize = (height / 100).toFixed(2)

                        ctx.restore()

                        ctx.font = fontSize + 'em Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji'
                        ctx.textBaseline = 'middle'
                        ctx.fillStyle = '#101827'

                        const text = `${progress.value}%`,
                            textX = Math.round((width - ctx.measureText(text).width) / 2),
                            textY = height / 2 + 1

                        ctx.fillText(text, textX, textY)
                        ctx.save()
                    }
                }]
            }

            onMounted(() => {
                let chart = new Chart(canvas.value, parameters)
                interval = setInterval(() => updateProgress(chart), 100)
            })

            onBeforeUnmount(() => {
                clearInterval(interval)
            })

            function updateProgress(chart) {
                scrollHeight.value = document.body.scrollTop || document.documentElement.scrollTop
                pageHeight.value = document.documentElement.scrollHeight - document.documentElement.clientHeight

                chart.data.datasets[0].data = [progress.value, 100 - progress.value]
                chart.update()
            }

            return {
                canvas,
            }
        }
    }
</script>